import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

const TextNavbar = styled.div`
    font-family: "HSE Sans";
    font-size: 18px;
`

export const useGetHseOnlineTabs = () => {

    const location = useLocation()
    const { t } = useTranslation()

    return {
        [NAVBAR_TAB_NAMES.hse_online_projects]: {
            content: <div>{t('nav.hse_online.projects')}</div>,
            linkTo: '/projects',
        },
        [NAVBAR_TAB_NAMES.hse_online_ba]: {
            active: (location.pathname === '/' || location.pathname === '/ba'),
            content: <div>{t('nav.hse_online.ba')}</div>,
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.hse_online_ma]: {
            content: <div>{t('nav.hse_online.ma')}</div>,
            linkTo: '/ma',
        },
        [NAVBAR_TAB_NAMES.hse_online_about]: {
            content: <div>{t('nav.hse_online.about')}</div>,
            linkTo: '/about',
        },
        [NAVBAR_TAB_NAMES.hse_online_join]: {
            content: <div>{t('nav.hse_online.join')}</div>,
            linkTo: '/join',
        },
        [NAVBAR_TAB_NAMES.hse_online_media]: {
            content: <div>{t('nav.hse_online.media')}</div>,
            linkTo: '/media',
        },
        [NAVBAR_TAB_NAMES.commdesign_program_page]: {
            content: <TextNavbar>Страница программы</TextNavbar>,
            linkTo: "/school/commdesign/1",
        },
    }
}import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

const TextNavbar = styled.div`
    font-family: "HSE Sans";
    font-size: 18px;
`

export const useGetHseOnlineTabs = () => {

    const location = useLocation()
    const { t } = useTranslation()

    return {
        [NAVBAR_TAB_NAMES.hse_online_projects]: {
            content: <div>{t('nav.hse_online.projects')}</div>,
            linkTo: '/projects',
        },
        [NAVBAR_TAB_NAMES.hse_online_ba]: {
            active: (location.pathname === '/' || location.pathname === '/ba'),
            content: <div>{t('nav.hse_online.ba')}</div>,
            linkTo: '/',
        },
        [NAVBAR_TAB_NAMES.hse_online_ma]: {
            content: <div>{t('nav.hse_online.ma')}</div>,
            linkTo: '/ma',
        },
        [NAVBAR_TAB_NAMES.hse_online_about]: {
            content: <div>{t('nav.hse_online.about')}</div>,
            linkTo: '/about',
        },
        [NAVBAR_TAB_NAMES.hse_online_join]: {
            content: <div>{t('nav.hse_online.join')}</div>,
            linkTo: '/join',
        },
        [NAVBAR_TAB_NAMES.hse_online_media]: {
            content: <div>{t('nav.hse_online.media')}</div>,
            linkTo: '/media',
        },
        [NAVBAR_TAB_NAMES.commdesign_program_page]: {
            content: <TextNavbar>Страница программы</TextNavbar>,
            linkTo: "/school/commdesign/1",
        },
    }
}